const ROLES = ["employee", "manager", "owner"];

function atLeastRole(role: PayrollRole | null | undefined, requiredRole: PayrollRole) {
  if (!role) return false;
  return ROLES.indexOf(requiredRole) <= ROLES.indexOf(role);
}

export { atLeastRole, ROLES };
